import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';
import { Login, TwoFactorAuth, ForgotPassword } from '@/pages/Login';
import { Logout } from '@/pages/Logout';
import { Profile } from '@/pages/Profile';
import { Partners } from '@/pages/Partners';
import { Application } from '@/pages/Application';
import { ApplicationAppStores } from '@/pages/ApplicationAppStores';
import { ApplicationDesign } from '@/pages/ApplicationDesign';
import { ApplicationHome } from '@/pages/ApplicationHome';
import { ApplicationNews } from '@/pages/ApplicationNews';
import { ApplicationBaladaApp } from '@/pages/ApplicationBaladaApp';
import { ApplicationSocialMedia } from '@/pages/ApplicationSocialMedia';
import { ApplicationCalendar } from '@/pages/ApplicationCalendar';
import { ApplicationCalendarEvents } from '@/pages/ApplicationCalendarEvents';
import { ApplicationCalendarWeekSchedule } from '@/pages/ApplicationCalendarWeekSchedule';
import { ApplicationTeams } from '@/pages/ApplicationTeams';
import { ApplicationTeam } from '@/pages/ApplicationTeam';
import { ApplicationRosterGroup } from '@/pages/ApplicationRosterGroup';
import { ApplicationRosterMember } from '@/pages/ApplicationRosterMember';
import { ApplicationHistory } from '@/pages/ApplicationHistory';
import { ApplicationHistoryTimeline } from '@/pages/ApplicationHistoryTimeline';
import { ApplicationHistoryGallery } from '@/pages/ApplicationHistoryGallery';
import { ApplicationUniformGallery } from '@/pages/ApplicationUniformGallery';
import { ApplicationIndicationsMap } from '@/pages/ApplicationIndicationsMap';
import { ApplicationCategoryVideo } from '@/pages/ApplicationCategoryVideo';
import { Home } from '@/pages/Home';
import { FundraisingCampaignScreen } from '@/pages/FundraisingCampaign';
import { InteractiveArea } from '@/pages/InteractiveArea';
import { Financial } from '@/pages/Financial';
import { FinancialTransactionDetail } from '@/pages/FinancialTransactionDetail';
import { AccessControl } from '@/pages/AccessControl';
import { AccessControlPermissionTypes } from '@/pages/AccessControlPermissionTypes';
import { AccessControlPermissionTypesNew } from '@/pages/AccessControlPermissionTypesNew';
import { AccessControlPermissionTypeEdit } from '@/pages/AccessControlPermissionTypeEdit';
import { AccessControlUserEdit } from '@/pages/AccessControlUserEdit';
import { ApplicationVideosChannel } from '@/pages/ApplicationVideosChannel';
import { ApplicationWonTitle } from '@/pages/ApplicationWonTitle';
import { ApplicationStore } from '@/pages/ApplicationStore';
import { AccountList } from '@/pages/AccountList';
import { AccountDetail } from '@/pages/AccountDetail';
import { CommunicationCentral } from '@/pages/CommunicationCentral';
import { ApplicationBanner } from '@/pages/ApplicationBannerHome';
import { ApplicationPredictions } from '@/pages/ApplicationPredictions';
import { InteractiveAreaPosts } from '@/pages/ApplicationPosts';
import { ApplicationPolls } from '@/pages/ApplicationPolls';
import { ApplicationChallenge } from '@/pages/ApplicationChallenge';
import { ApplicationChallengeCreate } from '@/pages/ApplicationChallengeCreate';
import { ApplicationChallengeEdit } from '@/pages/ApplicationChallengeEdit';
import { ApplicationHistoryAnthem } from '@/pages/ApplicationHistoryAnthem';
import { ApplicationSocialMediaLinks } from '@/pages/ApplicationSocialMediaLinks';
import { ApplicationSocialMediaFeed } from '@/pages/ApplicationSocialMediaFeed';
import { ApplicationSocialMediaVirais } from '@/pages/ApplicationSocialMediaVirais';
import { ApplicationStoreProducts } from '@/pages/ApplicationStoreProducts';
import { ApplicationStoreBanners } from '@/pages/ApplicationStoreBanners';
import { ApplicationChampionship } from '@/pages/ApplicationChampionship';
import { ApplicationChampionships } from '@/pages/ApplicationChampionships';
import { ApplicationChampionshipSeasonCreate } from '@/pages/ApplicationChampionshipSeasonCreate';
import { ApplicationChampionshipSeason } from '@/pages/ApplicationChampionshipSeason';
import { ApplicationChampionshipSeasonEdit } from '@/pages/ApplicationChampionshipSeasonEdit';
import { ApplicationChampionshipStageStandings } from '@/pages/ApplicationChampionshipStageStandings';
import { ApplicationChampionshipMatches } from '@/pages/ApplicationChampionshipMatches';

interface RouteProps {
  path: string;
  component: ReactNode;
  exact?: boolean;
}

const userRoutes: RouteProps[] = [
  { path: '*', component: <Navigate to='/' replace /> },

  {
    path: '/',
    component: <Home />,
  },

  {
    path: '/profile',
    component: <Profile />,
  },

  {
    path: '/account',
    component: <AccountList />,
  },
  {
    path: '/account/:id',
    component: <AccountDetail />,
  },

  {
    path: '/partners',
    component: <Partners />,
  },

  {
    path: '/application',
    component: <Application />,
  },

  {
    path: '/application/app-stores',
    component: <ApplicationAppStores />,
  },

  {
    path: '/application/design',
    component: <ApplicationDesign />,
  },

  {
    path: '/application/home',
    component: <ApplicationHome />,
  },

  // TODO: HIDE
  // {
  //   path: '/application/card',
  //   component: <ApplicationCard />,
  // },

  {
    path: '/application/news',
    component: <ApplicationNews />,
  },

  {
    path: '/application/balada-app',
    component: <ApplicationBaladaApp />,
  },

  {
    path: '/application/social-media',
    component: <ApplicationSocialMedia />,
  },

  {
    path: '/application/social-media/links',
    component: <ApplicationSocialMediaLinks />,
  },

  {
    path: '/application/social-media/feed',
    component: <ApplicationSocialMediaFeed />,
  },

  {
    path: '/application/social-media/viral-posts',
    component: <ApplicationSocialMediaVirais />,
  },

  {
    path: '/application/calendar',
    component: <ApplicationCalendar />,
  },
  {
    path: '/application/calendar/events',
    component: <ApplicationCalendarEvents />,
  },

  {
    path: '/application/calendar/week-schedule',
    component: <ApplicationCalendarWeekSchedule />,
  },

  {
    path: '/application/team',
    component: <ApplicationTeam />,
  },


  {
    path: '/application/team/roster-group',
    component: <ApplicationRosterGroup />,
  },

  {
    path: '/application/team/roster-member',
    component: <ApplicationRosterMember />,
  },

  {
    path: '/application/history',
    component: <ApplicationHistory />,
  },

  {
    path: '/application/history/timeline',
    component: <ApplicationHistoryTimeline />,
  },

  {
    path: '/application/history/anthem',
    component: <ApplicationHistoryAnthem />,
  },

  {
    path: '/application/history/gallery',
    component: <ApplicationHistoryGallery />,
  },

  {
    path: '/application/history/won-title',
    component: <ApplicationWonTitle />,
  },

  {
    path: '/application/history/uniform-gallery',
    component: <ApplicationUniformGallery />,
  },

  {
    path: '/application/indications-map',
    component: <ApplicationIndicationsMap />,
  },

  {
    path: '/application/videos-channel',
    component: <ApplicationVideosChannel />,
  },

  {
    path: '/application/videos-channel/categories',
    component: <ApplicationCategoryVideo />,
  },

  {
    path: '/application/store',
    component: <ApplicationStore />,
  },
  {
    path: '/application/store/products',
    component: <ApplicationStoreProducts />,
  },
  {
    path: '/application/store/banners',
    component: <ApplicationStoreBanners />,
  },

  {
    path: '/application/banners-home',
    component: <ApplicationBanner />,
  },

  // {
  //   path: '/application/exclusive-material',
  //   component: <ApplicationExclusiveMaterial />,
  // },

  // {
  //   path: '/application/benefits-club',
  //   component: <BenefitsClub />,
  // },

  {
    path: '/fundraising-campaign',
    component: <FundraisingCampaignScreen />,
  },

  {
    path: '/application/interactive-area',
    component: <InteractiveArea />,
  },

  {
    path: '/application/interactive-area/posts',
    component: <InteractiveAreaPosts />,
  },

  // {
  //   path: '/application/interactive-area/quizzes',
  //   component: <ApplicationQuiz />,
  // },

  {
    path: '/application/interactive-area/polls',
    component: <ApplicationPolls />,
  },

  {
    path: '/application/interactive-area/predictions',
    component: <ApplicationPredictions />,
  },

  {
    path: '/application/challenge',
    component: <ApplicationChallenge />,
  },

  {
    path: '/application/challenge/create',
    component: <ApplicationChallengeCreate />,
  },

  {
    path: '/application/challenge/:id',
    component: <ApplicationChallengeEdit />,
  },

  {
    path: '/financial',
    component: <Financial />,
  },

  {
    path: '/financial/:id',
    component: <FinancialTransactionDetail />,
  },

  {
    path: '/access-control',
    component: <AccessControl />,
  },

  {
    path: '/access-control/permission-types',
    component: <AccessControlPermissionTypes />,
  },

  {
    path: '/access-control/permission-types/new',
    component: <AccessControlPermissionTypesNew />,
  },

  {
    path: '/access-control/permission-types/:id',
    component: <AccessControlPermissionTypeEdit />,
  },

  {
    path: '/access-control/users/:id',
    component: <AccessControlUserEdit />,
  },

  {
    path: '/communication-central',
    component: <CommunicationCentral />,
  },

  {
    path: '/application/championships',
    component: <ApplicationChampionships />,
  },
  {
    path: '/application/championships/championship',
    component: <ApplicationChampionship />,
  },
  {
    path: '/application/championships/seasons/create',
    component: <ApplicationChampionshipSeasonCreate />,
  },
  {
    path: '/application/championships/seasons',
    component: <ApplicationChampionshipSeason />,
  },
  {
    path: '/application/championships/seasons/:id/edit',
    component: <ApplicationChampionshipSeasonEdit />,
  },
  {
    path: '/application/championships/matches',
    component: <ApplicationChampionshipMatches />,
  },
  {
    path: '/application/championships/standings',
    component: <ApplicationChampionshipStageStandings />,
  },

  {
    path: '/application/championships/teams',
    component: <ApplicationTeams />,
  },
];

const authRoutes: Array<RouteProps> = [
  //Authentication pages
  { path: '/login', component: <Login /> },
  { path: '/login/2fa', component: <TwoFactorAuth /> },
  { path: '/login/esqueci-minha-senha', component: <ForgotPassword /> },

  { path: '/logout', component: <Logout /> },
];

export { userRoutes, authRoutes };
